import React, {createElement} from 'react';
import {isMobile} from 'react-device-detect';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {ReactComponent as emptyListIcon} from '../../assets/icons/transports/no-results.svg';
import {analyticsEvent} from '../../utils/analytics';

import './emptyList.scss';

function EmptyList(props: any) {
    const {t} = useTranslation();

    const handleClick = () => {
        analyticsEvent('Cercador', 'search_search_click');
    };

    return (<div className="empty-list">
        <div className="empty-list-icon">
            {createElement(emptyListIcon)}
        </div>
        <h3 className="empty-list-title">
            {t('translation:commons_transport_stops_not_found')}
        </h3>
        <p className="empty-list-description">
            {t('translation:transport_line_empty_result_title')}
        </p>
        {(isMobile) ?
            <div className="back-to-map">
                <Link to="/" className="btn btn-primary">
                    <span
                        className="back-to-map__button"
                        onKeyDown={handleClick}
                        role="button"
                        tabIndex={0}
                        onClick={handleClick}
                    >
                        {t('translation:transport_search_no_results_button_text')}
                    </span>
                </Link>
            </div> : ''
        }
    </div>
    );
}

export default EmptyList;
